import { CodeExpirationCountdown } from '~/@mid_2fa/twofa/CodeExpirationCountdown'
import { useTwoFaCodeExpirationCountdown } from '~/@mid_2fa/twofa/useTwoFaCodeExpirationCountdown'
import { SmsLoginLinkIcon } from '~/@mid_ui/icons/SmsLoginLinkIcon'
import { HeadingTwo } from '~/@mid_ui/typography/HeadingTwo'
import { Text } from '~/@mid_ui/typography/Text'
import { Button } from '~/shadcn/ui/button/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '~/shadcn/ui/dialog'
import { Spinner } from '~/shadcn/ui/spinner'

type Props = {
  title: string
  description: string
  onClose?: () => void
  expiresAt: Date | null
  handleResendSms(): void
  isSendingSms: boolean
}

function IdentityVerificationSocialInAppWebViewDialog({
  title,
  description,
  onClose,
  expiresAt,
  handleResendSms,
  isSendingSms,
}: Props) {
  const { countdown, hasCodeExpired } =
    useTwoFaCodeExpirationCountdown(expiresAt)

  return (
    <Dialog open onOpenChange={(open) => !open && onClose?.()}>
      <DialogContent>
        <div className="flex flex-col text-center md:gap-2 gap-4 p-4">
          <DialogTitle asChild className="text-center">
            <HeadingTwo>{title}</HeadingTwo>
          </DialogTitle>
          <DialogDescription asChild>
            <Text
              className={
                hasCodeExpired ? 'text-center' : '!text-foreground text-center'
              }>
              {hasCodeExpired ? 'SMS odkaz vypršal.' : description}
            </Text>
          </DialogDescription>
          <div className="flex flex-col items-center gap-6 text-center mt-6">
            {!hasCodeExpired ? (
              <>
                <SmsLoginLinkIcon className="w-full" />
                <CodeExpirationCountdown
                  countdown={countdown}
                  textationOverride="Platnosť SMS odkazu"
                />
              </>
            ) : (
              <Button
                variant="outline"
                disabled={isSendingSms}
                onClick={handleResendSms}>
                Znova odoslať SMS odkaz{` `}
                {isSendingSms && <Spinner className="size-4" />}
              </Button>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export { IdentityVerificationSocialInAppWebViewDialog }
